import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UserFormComponent } from './user-form/user-form.component';
import { UserComponent } from './user.component';
import { UserRoutes } from './user.routing';

export function declaration() {
    return [UserComponent, UserFormComponent, ResetPasswordComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class UserModule {
}

@NgModule({
    imports: [UserModule, UserRoutes],
    exports: [UserModule]
})
export class UserWithRouteModule {
}
